export const SESSION_TIMEOUT_EVENT = 'bienlivrer-session-timeout-changed';

/** @deprecated Utiliser SESSION_TIMEOUT_EVENT */
export const ADMIN_SESSION_TIMEOUT_EVENT = SESSION_TIMEOUT_EVENT;

export const DEFAULT_INACTIVITY_MINUTES = 30;

/** 0 = déconnexion automatique désactivée */
export const INACTIVITY_MINUTE_OPTIONS = [15, 30, 60, 120, 240, 0] as const;

export type InactivityMinutes = (typeof INACTIVITY_MINUTE_OPTIONS)[number];

/** @deprecated Utiliser InactivityMinutes */
export type AdminInactivityMinutes = InactivityMinutes;

/** @deprecated Utiliser INACTIVITY_MINUTE_OPTIONS */
export const ADMIN_INACTIVITY_MINUTE_OPTIONS = INACTIVITY_MINUTE_OPTIONS;

/** @deprecated Utiliser DEFAULT_INACTIVITY_MINUTES */
export const DEFAULT_ADMIN_INACTIVITY_MINUTES = DEFAULT_INACTIVITY_MINUTES;

function storageKey(userId: string): string {
  return `bienlivrer-inactivity-minutes-${userId}`;
}

function legacyAdminStorageKey(userId: string): string {
  return `bienlivrer-admin-inactivity-minutes-${userId}`;
}

export function getInactivityMinutes(userId: string): InactivityMinutes {
  try {
    const raw =
      localStorage.getItem(storageKey(userId)) ??
      localStorage.getItem(legacyAdminStorageKey(userId));
    if (raw === null) return DEFAULT_INACTIVITY_MINUTES;
    const n = Number(raw);
    if (INACTIVITY_MINUTE_OPTIONS.includes(n as InactivityMinutes)) {
      return n as InactivityMinutes;
    }
  } catch {
    /* ignore */
  }
  return DEFAULT_INACTIVITY_MINUTES;
}

/** @deprecated Utiliser getInactivityMinutes */
export const getAdminInactivityMinutes = getInactivityMinutes;

export function setInactivityMinutes(userId: string, minutes: InactivityMinutes): void {
  try {
    localStorage.setItem(storageKey(userId), String(minutes));
    window.dispatchEvent(
      new CustomEvent(SESSION_TIMEOUT_EVENT, { detail: { userId, minutes } }),
    );
  } catch {
    /* ignore */
  }
}

/** @deprecated Utiliser setInactivityMinutes */
export const setAdminInactivityMinutes = setInactivityMinutes;
